import type { IFrontFooterLayoutProps } from '@framework/theme/src/front/FrontFooterLayout';
import { ContentLayoutWrapper } from '@framework/ui';
import { Divider, Layout } from 'antd';
import clx from 'classnames';
import { down } from 'styled-breakpoints';
import styled from 'styled-components';
import { FooterFrontPolicyRow } from './footer/FooterFrontPolicyRow';
import { FrontFooterContent } from './footer/FrontFooterContent';

const StyledFooter = styled(Layout.Footer)`
  &&& {
    background-color: ${props => props.theme.colorPrimary};
    color: #fff;
    font-size: 18px;
    width: 100%;
    padding: 40px 16px;
    z-index: 11;
    height: auto;
    line-height: unset;
    &.boxed {
      padding: 40px 0;
    }
    a:focus-visible {
      outline: 2px solid ${props => props.theme.focusOutlineNegativeColor};
      outline-offset: 3px;
      border-radius: 3px;
    }
    overflow-x: hidden;
  }
`;
const BoxedPaddingWrapper = styled.div`
  flex-wrap: nowrap;
  max-width: 100%;
  padding: 0 24px;
  ${down('sm')} {
    padding: 0 12px;
  }
`;

/**
 * Footer dell'applicativo.
 */
export function FrontFooterLayout(props: IFrontFooterLayoutProps) {
  const { boxed = true } = props;

  return (
    <StyledFooter className={clx({ boxed })} id="main-footer">
      <ContentLayoutWrapper boxed={boxed}>
        <BoxedPaddingWrapper>
          <FrontFooterContent />
          <Divider />
          <FooterFrontPolicyRow />
        </BoxedPaddingWrapper>
      </ContentLayoutWrapper>
    </StyledFooter>
  );
}
